import { cloneDeep } from 'lodash-es';

import transformData from './transform-data';

/**
 * param URL参数字符串
 *
 * return 提取后的对象
 */
function getParams(url) {
  const res = {};
  if (url.includes('?')) {
    const str = url.split('?')[1];
    const arr = str.split('&');
    arr.forEach((item) => {
      const key = item.split('=')[0];
      const val = item.split('=')[1];
      res[key] = decodeURIComponent(val); // 解码
    });
  }
  return res;
}

/**
 * param 将要转为URL参数字符串的对象
 * key URL参数字符串的前缀
 * encode true/false 是否进行URL编码,默认为true
 *
 * return URL参数字符串
 */

function urlEncode(param, key, encode) {
  if (param == null) return '';
  let paramStr = '';
  const t = typeof param;
  if (t == 'string' || t == 'number' || t == 'boolean') {
    paramStr += '&' + key + '=' + (encode == null || encode ? encodeURIComponent(param) : param);
  } else {
    for (const i in param) {
      const k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
      paramStr += urlEncode(param[i], k, encode);
    }
  }
  return paramStr;
}

/**
 * desc 获取去除域名和查询参数后的接口地址
 * param 完整接口地址
 *
 * return 如 https://member.szlcsc.com/get/resource?name=long => /get/resource
 */

function getUrlRelativePath(configUrl) {
  if (!configUrl) return configUrl;
  let url = configUrl.toString();
  if (url.split('//').length === 1) {
    url = location.origin + url; // 手动添加域名
  }
  const arrUrl = url.split('//');
  const start = arrUrl[1].indexOf('/');
  let relUrl = arrUrl[1].substring(start); //stop省略，截取从start开始到结尾的所有字符

  if (relUrl.indexOf('?') != -1) {
    relUrl = relUrl.split('?')[0];
  }
  return relUrl;
}

/**
 * desc 发送请求时，用于get请求的查询参数加密
 * param xhr对象 , needEncryptFields 需要加密的字段
 *
 * return 加密后的xhr对象
 */
function getEncrypt(config, needEncryptFields) {
  const originUrl = config.url.split('?')[0];
  let params = getParams(config.url);
  // 加密
  params = transformData(params, 'ENCRYPT', needEncryptFields);
  config.url = originUrl + '?' + urlEncode(params).slice(1); // urlEncode 把首个&变成?
  return config;
}

/**
 * desc 发送请求时，用于post请求的body参数加密
 * param xhr对象, needEncryptFields 需要加密的字段
 *
 * return 加密后的xhr对象
 */
function postEncrypt(config, needEncryptFields) {
  // 加密
  const data = transformData(config.data, 'ENCRYPT', needEncryptFields);
  config.data = data;
  return config;
}

/**
 * desc 请求结果返回时，对请求结果的解密
 * param xhr对象
 *
 * return 解密后的xhr对象
 */
function resDecrypt(res, needEncryptFields) {
  const response = JSON.parse(res.response);
  // 解密
  response.result = transformData(cloneDeep(response.result), 'DECRYPT', needEncryptFields);
  res.response = JSON.stringify(response);
  return res;
}

export { getEncrypt, postEncrypt, resDecrypt, getUrlRelativePath, urlEncode };
